import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import PropTypes from "prop-types";
import MDModal from "components/MDModal";
import MetrimonialForm from "./Form";
import { getMatrimonialListApi } from "Apis/matrimonialApi";
import React, { useContext, useEffect, useState } from "react";
import { MetrimonialContext } from "context/MetrimonialContext";
import { getMatrimonialDataByIdApi } from "Apis/matrimonialApi";
import { ModalContext } from "context/ModalContext";
import { deleteMatrimonialDataApi, verifyMatrimonialDataApi } from "Apis/matrimonialApi";
import Swal from "sweetalert2";
import { LoginFormContext } from "context/LoginFormContext";
import { MODULES } from "helpers/constant";
import UpdateStatus from "components/MDUpdateStatus";
import { Avatar } from "@mui/material";
import { MemberContext } from "context/MemberContext";
import VerifiedIcon from "@mui/icons-material/Verified";
import MDActionButton from "components/MDActionButton";
import colors from "assets/theme/base/colors";
import VerifiedStatus from "components/MDVerifiedStatus";
import Imagepreview from "components/MDImagePreview";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import moment from "moment";

function MetrimonialTable() {
  const { setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const { matrimonialData, setMatrimonialData, setEditData } = useContext(MetrimonialContext);
  const {
    setNotification,
    modules,
    getModuleAccess,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
    access,
  } = useContext(LoginFormContext);
  const { parentDataListing } = useContext(MemberContext);
  const { imageBorder } = colors;
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });

  const [filterVal, setFilterVal] = useState({
    full_name: "",
    marital_status: "",
    gender: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  const obj = {
    ...defaultFilter,
    filters: {
      full_name: filterVal.full_name,
      birth_date: filterVal.birth_date,
      marital_status: filterVal.marital_status?.value,
      gender: filterVal?.gender?.value,
      is_active: filterVal?.is_active?.value,
      is_verified: filterVal?.is_verified?.value,
    },
  };

  const getmatrimonialAllData = async (data) => {
    let response = await getMatrimonialListApi(obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setMatrimonialData(response.data.data.rows);
      setRowCount(response?.data?.data?.count);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.MATRIMONIAL);
  }, [modules]);

  useEffect(() => {
    getmatrimonialAllData();
  }, [filterVal, defaultFilter]);

  useEffect(() => {
    parentDataListing();
  }, []);

  const handleEdit = async (row) => {
    let response = await getMatrimonialDataByIdApi(row.id);
    if (response?.status === 200) {
      setOpen(true);
      setFormIsEdit(true);
      setEditData(response?.data?.data);
    }
  };

  const handleDelete = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want really to delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      let response = await deleteMatrimonialDataApi(row.id);
      if (response?.status === 200) {
        setFilterLoader(false);
        matrimonialData?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
        getmatrimonialAllData();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "check",
          title: "error",
          content: response.data.message,
          open: true,
        });
      }
    }
  };

  const handleVerify = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want really to verify this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, verify it!",
    });
    if (result.isConfirmed) {
      let response = await verifyMatrimonialDataApi(row.id);
      if (response?.status === 200) {
        setFilterLoader(false);
        matrimonialData?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
        getmatrimonialAllData();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "check",
          title: "error",
          content: response.data.message,
          open: true,
        });
      }
    }
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  const handleDownload = (fileUrl) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = fileUrl.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileURL);
      })
      .catch((error) => {
        console.error("Download error:", error);
      });
  };

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "Full Name",
        accessor: "full_name",
        sort: true,
        filterLabel: "Full Name",
        filterAccessor: "full_name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value, row }) => {
          const findImage = row?.original?.matrimonial_documents.find(
            (data) => data?.type === "Image"
          );

          const [imgError, setImgError] = React.useState(false);
          const isVerified = row?.original?.is_verified === 1;

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {findImage && !imgError ? (
                <div style={{ position: "relative", display: "inline-block" }}>
                  {row?.original?.matrimonial_documents.map((data, index) => {
                    if (data?.type === "Image") {
                      return (
                        <img
                          key={index}
                          src={data?.image}
                          alt="image"
                          onError={() => setImgError(true)}
                          onClick={() => handleImageClick(data?.image)}
                          style={{
                            height: "50px",
                            width: "50px",
                            borderRadius: "100%",
                            objectFit: "fill",
                            border: `1px solid ${imageBorder.borderColor}`,
                            cursor: "pointer",
                          }}
                        />
                      );
                    }
                    return null;
                  })}
                  {isVerified && (
                    <VerifiedIcon
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        width: "16px",
                        height: "16px",
                        color: `${imageBorder.verifiedIconColor}`,
                      }}
                    />
                  )}
                </div>
              ) : (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <Avatar
                    sx={{
                      height: "50px",
                      width: "50px",
                      "&:hover": {
                        background: `${imageBorder.backgroundColor} !important`,
                      },
                    }}
                  />
                  {isVerified && (
                    <VerifiedIcon
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        width: "18px",
                        height: "18px",
                        color: `${imageBorder.verifiedIconColor}`,
                      }}
                    />
                  )}
                </div>
              )}
              <DefaultCell value={value || "-"} />
            </div>
          );
        },
      },
      {
        Header: "Marital Status",
        accessor: "marital_status",
        sort: true,
        filterLabel: "Marital Status",
        filterAccessor: "marital_status",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Unmarried", value: "Unmarried" },
          { label: "Divorced", value: "Divorced" },
          { label: "Separated", value: "Separated" },
          { label: "Widowed", value: "Widowed" },
        ],
        Cell: ({ value }) => <DefaultCell value={value || "-"} />,
      },
      {
        Header: "Gender",
        accessor: "gender",
        sort: true,
        filterLabel: "Gender",
        filterAccessor: "gender",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Male", value: "Male" },
          { label: "Female", value: "Female" },
        ],
        Cell: ({ value }) => <DefaultCell value={value || "-"} />,
      },
      {
        Header: "Verification Status",
        accessor: "is_verified",
        minWidth: "115px",
        sort: true,
        filterLabel: "Verification Status",
        filterAccessor: "is_verified",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Verified", value: "1" },
          { label: "Not Verified", value: "0" },
        ],
        Cell: ({ value }) => <VerifiedStatus data={value} />,
      },
      {
        Header: "Created date",
        accessor: "createdAt",
        sort: true,
        Cell: ({ value }) => (
          <DefaultCell value={value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"} />
        ),
      },
      {
        Header: "Status",
        accessor: "is_active",
        minWidth: "115px",
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="matrimonials"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ row }) => {
          const { matrimonial_documents } = row.original;
          const pdfDocument = matrimonial_documents?.find((doc) => doc?.type === "Document");

          return (
            <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {access?.write_access && (
                <MDActionButton type="edit" onClick={() => handleEdit(row.original)} />
              )}
              {access?.delete_access && (
                <MDActionButton type="delete" onClick={() => handleDelete(row.original)} />
              )}
              {pdfDocument && (
                <MDActionButton type="download" onClick={() => handleDownload(pdfDocument.image)} />
              )}
              {access?.write_access && row.original.is_verified === 0 && (
                <MDActionButton type="verify" onClick={() => handleVerify(row.original)} />
              )}
            </MDBox>
          );
        },
      },
    ],
    rows: matrimonialData,
  };

  return (
    !isLoading && (
      <DashboardLayout>
        <DashboardNavbar />
        <>
          <MDModal
            hasButton={access?.write_access ?? false}
            btnText="Add Matrimonial"
            modalHead={`${formIsEdit ? "Edit" : "Add"} Matrimonial`}
          >
            <MetrimonialForm getmatrimonialAllData={getmatrimonialAllData} />
          </MDModal>
          <DataTable
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            canSearch={true}
            getDataList={getmatrimonialAllData}
            rowCount={rowCount}
            tableTitle="Matrimonial List"
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
          {selectedImage && (
            <Imagepreview
              open={isImageModalOpen}
              onClose={() => setIsImageModalOpen(false)}
              imageUrl={selectedImage}
            />
          )}
        </>
      </DashboardLayout>
    )
  );
}
MetrimonialTable.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default MetrimonialTable;
